import { borderRadiusRounded, controlPaddingBlock, controlSizeFallback, cssControlSize, cssSpacing, cursorDisabled, opacityActive, opacityDisabled, rootStyle, slControlSize } from "../index.mjs";
import { css } from "../../styled-components.mjs";
/* The css variable is intentionally undefined so that Ads Business can easily override this */
export var buttonBorderRadius = "var(--encore-button-corner-radius, ".concat(borderRadiusRounded, ")");
export var buttonHoverScale = '1.04';

/** Observed margin between icons and text (absolute positioned, not real margin) */
export var buttonWithIconMargin = {
  small: '5px',
  medium: '12px' /* TODO: can we use an encore token here? */,
  large: '10px'
};
export var defaultTypeVariants = {
  sm: 'mestoBold',
  md: 'balladBold',
  lg: 'cello'
};
export var getButtonFont = function getButtonFont(buttonSize) {
  switch (buttonSize) {
    case 'small':
      return 'bodySmallBold';
    case 'medium':
      return 'bodyMediumBold';
    case 'large':
      return 'bodyMediumBold';
    default:
      return 'bodyMediumBold';
  }
};

/** Utility so we can have a pretty style when we don't need to account for the borderWidth */
function calculatePaddingWithBorder(_ref) {
  var property = _ref.property,
    value = _ref.value,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth;
  if (borderWidth > 0) {
    return css(["", ":calc(", " - ", "px);"], property, value, borderWidth);
  }
  return css(["", ":", ";"], property, value);
}

/**
 * Used by primary, secondary, tertiary
 * The padding block properties should be the same for all three types of buttons
 */
function getPaddingBlock(_ref2) {
  var buttonSize = _ref2.buttonSize,
    _ref2$borderWidth = _ref2.borderWidth,
    borderWidth = _ref2$borderWidth === void 0 ? 0 : _ref2$borderWidth;
  switch (buttonSize) {
    case 'small':
      {
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-block',
          value: cssSpacing('tighter-4', controlPaddingBlock.small),
          borderWidth: borderWidth
        }));
      }
    case 'large':
      {
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-block',
          value: cssSpacing('tighter', controlPaddingBlock.large),
          borderWidth: borderWidth
        }));
      }
    default:
      {
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-block',
          value: cssSpacing('tighter-2', controlPaddingBlock.medium),
          borderWidth: borderWidth
        }));
      }
  }
}

/**
 * Used by primary, secondary, tertiary
 * Takes into account tertiary's condensed prop
 */
export function getNoneIconsPadding(_ref3) {
  var buttonSize = _ref3.buttonSize,
    _ref3$borderWidth = _ref3.borderWidth,
    borderWidth = _ref3$borderWidth === void 0 ? 0 : _ref3$borderWidth,
    condensed = _ref3.condensed;
  var paddingInline = function paddingInline() {
    switch (buttonSize) {
      case 'small':
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-inline',
          value: cssSpacing('base', '16px'),
          borderWidth: borderWidth
        }));
      case 'large':
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-inline',
          value: cssSpacing('looser-3', '48px'),
          borderWidth: borderWidth
        }));
      default:
        return css(["", ";"], calculatePaddingWithBorder({
          property: 'padding-inline',
          value: cssSpacing('looser-2', '32px'),
          borderWidth: borderWidth
        }));
    }
  };
  if (condensed) {
    paddingInline = function paddingInline() {
      return css(["padding-inline:0;"]);
    };
  }
  return css(["", ";", ";"], getPaddingBlock({
    buttonSize: buttonSize,
    borderWidth: borderWidth
  }), paddingInline);
}

/** Used by primary & secondary */
function getWithIconPadding(_ref4) {
  var buttonSize = _ref4.buttonSize,
    iconPlacement = _ref4.iconPlacement,
    _ref4$borderWidth = _ref4.borderWidth,
    borderWidth = _ref4$borderWidth === void 0 ? 0 : _ref4$borderWidth;
  var paddingInline = function paddingInline() {
    switch (buttonSize) {
      case 'small':
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  /** --encore-spacing-looser-2 resolves to 33px so we are just using hard coded values here until we refactor our buttons to be able to correcly use SL tokens */
                  value: '33px',
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: cssSpacing('base', '16px'),
                  borderWidth: borderWidth
                }));
              }
            case 'trailing':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  value: cssSpacing('base', '16px'),
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: '33px',
                  borderWidth: borderWidth
                }));
              }
            default:
              {
                return css(["", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline',
                  value: '33px',
                  borderWidth: borderWidth
                }));
              }
          }
        }
      case 'large':
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  /** --encore-spacing-looser-4 resolves to 64px so we are just using hard coded values here until we refactor our buttons to be able to correcly use SL tokens */
                  value: '58px',
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: cssSpacing('looser-3', '48px'),
                  borderWidth: borderWidth
                }));
              }
            case 'trailing':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  value: cssSpacing('looser-3', '48px'),
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: '58px',
                  borderWidth: borderWidth
                }));
              }
            default:
              {
                return css(["", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline',
                  value: '58px',
                  borderWidth: borderWidth
                }));
              }
          }
        }
      default:
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  /** --encore-spacing-looser-3 resolves to 48px so we are just using hard coded values here until we refactor our buttons to be able to correcly use SL tokens */
                  value: '56px' /* TODO: can we use an encore token here? */,
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: cssSpacing('looser-2', '32px'),
                  borderWidth: borderWidth
                }));
              }
            case 'trailing':
              {
                return css(["", ";", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline-start',
                  value: cssSpacing('looser-2', '32px'),
                  borderWidth: borderWidth
                }), calculatePaddingWithBorder({
                  property: 'padding-inline-end',
                  value: '56px' /* TODO: can we use an encore token here? */,
                  borderWidth: borderWidth
                }));
              }
            default:
              {
                return css(["", ";"], calculatePaddingWithBorder({
                  property: 'padding-inline',
                  value: '56px' /* TODO: can we use an encore token here? */,
                  borderWidth: borderWidth
                }));
              }
          }
        }
    }
  };
  return css(["", ";", ";"], getPaddingBlock({
    buttonSize: buttonSize,
    borderWidth: borderWidth
  }), paddingInline);
}
export function getTertiaryWithIconPadding(_ref5) {
  var buttonSize = _ref5.buttonSize,
    iconPlacement = _ref5.iconPlacement,
    condensed = _ref5.condensed;
  var paddingInline = function paddingInline() {
    switch (buttonSize) {
      case 'small':
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["padding-inline:", " ", ";"], cssSpacing('tighter', '12px'), cssSpacing('base', '16px'));
              }
            case 'trailing':
              {
                return css(["padding-inline:", " ", ";"], cssSpacing('base', '16px'), cssSpacing('tighter', '12px'));
              }
            default:
              {
                return css(["padding-inline:", ";"], cssSpacing('tighter', '12px'));
              }
          }
        }
      case 'large':
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["padding-inline:", " ", ";"], cssSpacing('looser-2', '24px'), cssSpacing('looser-3', '48px'));
              }
            case 'trailing':
              {
                return css(["padding-inline:", " ", ";"], cssSpacing('looser-3', '48px'), cssSpacing('looser-2', '24px'));
              }
            default:
              {
                return css(["padding-inline:", ";"], cssSpacing('looser-2', '24px'));
              }
          }
        }
      default:
        {
          switch (iconPlacement) {
            case 'leading':
              {
                return css(["padding-inline:20px ", ";"], cssSpacing('looser-2', '32px'));
              }
            case 'trailing':
              {
                return css(["padding-inline:", " 20px;"], cssSpacing('looser-2', '32px'));
              }
            default:
              {
                return css(["padding-inline:20px;"]);
              }
          }
        }
    }
  };
  if (condensed) {
    paddingInline = function paddingInline() {
      return css(["padding-inline:0;"]);
    };
  }
  return css(["", ";", ";"], getPaddingBlock({
    buttonSize: buttonSize,
    borderWidth: buttonSize === 'medium' ? 2 : 0
  }), paddingInline);
}
export function getIconPlacement() {
  var icons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var iconOnly = icons.iconOnly,
    iconLeading = icons.iconLeading,
    iconTrailing = icons.iconTrailing;
  if (iconOnly) {
    return 'only';
  }
  if (iconLeading && iconTrailing) {
    return 'both';
  }
  if (iconLeading) {
    return 'leading';
  }
  if (iconTrailing) {
    return 'trailing';
  }
  return 'none';
}

/** Used by primary & secondary */
/* CSS migration: use component level button styles to replace.
  - base naming pattern is <buttoncomponentname>-<deprecated?>--<size>
  - for button primary, add the __inner element to the class name
  - for buttons with icons (not iconOnly), also add <buttoncomponentname>--<iconPosition> class
  - iconOnly uses the shared .button-icon-only--<size> class instead
  */
export var getButtonPadding = function getButtonPadding(_ref6) {
  var buttonSize = _ref6.buttonSize,
    _ref6$borderWidth = _ref6.borderWidth,
    borderWidth = _ref6$borderWidth === void 0 ? 0 : _ref6$borderWidth,
    iconPlacement = _ref6.iconPlacement;
  /** iconOnly buttons used fixed width & height instead of padding */
  var iconOnlyDimensions = css(["inline-size:", ";block-size:", ";"], cssControlSize(slControlSize(buttonSize), controlSizeFallback[buttonSize]), cssControlSize(slControlSize(buttonSize), controlSizeFallback[buttonSize]));
  if (iconPlacement === 'only') {
    return iconOnlyDimensions;
  }
  if (iconPlacement === 'none') {
    return getNoneIconsPadding({
      buttonSize: buttonSize,
      borderWidth: borderWidth
    });
  }
  return getWithIconPadding({
    buttonSize: buttonSize,
    iconPlacement: iconPlacement,
    borderWidth: borderWidth
  });
};
var getTertiaryIconOnlyPadding = function getTertiaryIconOnlyPadding(_ref7) {
  var buttonSize = _ref7.buttonSize,
    condensed = _ref7.condensed;
  /** medium & large buttons have the same padding */
  var paddingBlock = css(["padding-block:", ";"], cssSpacing('tighter', '12px'));
  var paddingInline = css(["padding-inline:", ";"], cssSpacing('tighter', '12px'));
  if (buttonSize === 'small') {
    paddingBlock = css(["padding-block:", ";"], cssSpacing('tighter-2', '8px'));
    paddingInline = css(["padding-inline:", ";"], cssSpacing('tighter-2', '8px'));
  }
  if (condensed) {
    paddingInline = css(["padding-inline:0;"]);
  }
  return css(["", ";", ";"], paddingBlock, paddingInline);
};

/* CSS migration: use component level button styles to replace.
  - base naming pattern is <buttoncomponentname>-<deprecated?>--<size>
  - for buttons with icons(not iconOnly), also add <buttoncomponentname>-<-iconPosition?>--<size> class
  - iconOnly uses the shared .button-icon-only--<size> class instead
  */
export var getTertiaryButtonPadding = function getTertiaryButtonPadding(_ref8) {
  var buttonSize = _ref8.buttonSize,
    iconPlacement = _ref8.iconPlacement,
    condensed = _ref8.condensed,
    condensedAll = _ref8.condensedAll;
  if (condensedAll) {
    return css(["padding:0;"]);
  }
  if (iconPlacement === 'only') {
    return getTertiaryIconOnlyPadding({
      buttonSize: buttonSize,
      condensed: condensed
    });
  }
  if (iconPlacement === 'none') {
    return getNoneIconsPadding({
      buttonSize: buttonSize,
      condensed: condensed
    });
  }
  return getTertiaryWithIconPadding({
    buttonSize: buttonSize,
    iconPlacement: iconPlacement,
    condensed: condensed
  });
};

/** Base styles shared by most buttons, including root style, focus reset and font sizes */
/* CSS migration: replace with "button" and "baseline" classes */
export var buttonStylesBase = function buttonStylesBase() {
  return css(["", ";background-color:transparent;border:0;border-radius:", ";cursor:pointer;display:inline-block;text-align:center;text-decoration:none;touch-action:manipulation;transition-duration:var(--shortest-3);transition-timing-function:var(--productive);user-select:none;vertical-align:middle;will-change:transform;"], rootStyle(), buttonBorderRadius);
};

/** Disabled styles shared by most buttons */
/* CSS migration: apply base 'button' class to activate these styles via disabled attr
  apply "button--disabled" class to trigger via prop.
*/
export var buttonStylesDisabled = css(["cursor:", ";opacity:", ";transform:scale(1);"], cursorDisabled, opacityDisabled);

/** Active styles shares by most buttons */
/* CSS migration: apply base 'button' class to activate these styles via state
  apply "button--active" class to trigger via prop.
*/
export var buttonStylesActive = css(["opacity:", ";transform:scale(1);"], opacityActive);

/** Hover styles shares by most buttons */
/* CSS migration: apply base 'button' class to activate these styles via state
  apply "button--hover" class to trigger via prop.
*/
export var buttonStylesHover = css(["transition-duration:var(--shortest-1);@media (prefers-reduced-motion:no-preference){transform:scale(", ");}"], buttonHoverScale);

// Reset a button to a link looking thing
/* CSS migration: replace with "button-link-reset" class */
export var buttonLinkReset = function buttonLinkReset() {
  var useBrowserDefaultFocusStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var keepOutline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return css(["background-color:transparent;border:0;color:inherit;cursor:pointer;line-height:1;letter-spacing:inherit;padding:0;", ";"], !useBrowserDefaultFocusStyle && !keepOutline && css(["&:focus{outline:none;}"]));
};